import { useMemo } from "react";
import { cn } from "@/lib/utils";

export const BRAND_NAME = "Aurora Geriátrica";
export const BRAND_SUBTITLE = "Plataforma clínica especializada en geriatría";

/**
 * Rutas públicas oficiales bajo /assets/logo/
 *
 * - icon*: isotipo (equivalente entre svg y png).
 * - wordmarkPng: wordmark / logo completo (única versión fiel en repo).
 * - markSvg: monograma compacto “AG” (no equivale al wordmark PNG).
 */
export const BRAND_LOGO = {
  iconSvg: "/assets/logo/logo-icon.svg",
  iconPng: "/assets/logo/logo-icon.png",
  wordmarkPng: "/assets/logo/logo-wordmark.png",
  markSvg: "/assets/logo/logo-mark.svg",
};

const SIZE_MAP = {
  sm: "h-8",
  md: "h-16",
  lg: "h-[120px]",
};

function normalizeVariant(variant) {
  if (variant === "logo" || variant === "full") return "wordmark";
  return variant;
}

/**
 * @param {"wordmark"|"icon"|"full"|"logo"} [variant]
 *   - wordmark: barandilla / hero con wordmark (PNG) o marca compacta SVG en espacios reducidos.
 *   - icon: isotipo.
 *   - full, logo: alias de wordmark (compat).
 * @param {"svg"|"png"} [format] — En wordmark, svg → markSvg (no es el wordmark PNG). Para el logo completo real usar format="png".
 */
export function Logo({ variant = "wordmark", size = "md", format = "svg", className = "", alt = BRAND_NAME }) {
  const v = normalizeVariant(variant);
  const src = useMemo(() => {
    const raster = format === "png";
    if (v === "icon") {
      return raster ? BRAND_LOGO.iconPng : BRAND_LOGO.iconSvg;
    }
    return raster ? BRAND_LOGO.wordmarkPng : BRAND_LOGO.markSvg;
  }, [v, format]);

  return (
    <img
      src={src}
      alt={alt}
      className={cn(
        "w-auto shrink-0 object-contain bg-transparent border-0 shadow-none",
        SIZE_MAP[size] || SIZE_MAP.md,
        className
      )}
    />
  );
}
